import { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { Service } from '../../../../models/masters/service';
import { useLoadData } from '../../../../hooks/useLoadData';
import { SiTrackGrid } from '../../../../components/si-track-grid/si-track-grid';
import { ApiResponse } from '../../../../models/api-response';
import { servicesApiKeyStore } from '../../../../api/masters/services-api-key-store';
import { munimappingdialogcolumns } from './muni-mapping-dialog-columns';
import { UserPermissionName } from '../../../../models/user-permission-name';

interface MunicipalityMappingGridProps {
  municipalityID: number;
  allServices: Service[];
  onSelectedItems: (items: Service[]) => void;
}

export const MunicipalityMappingGrid = ({
  municipalityID,
  allServices,
  onSelectedItems,
}: MunicipalityMappingGridProps) => {
  const [selectedServices, setSelectedServices] = useState<Service[]>([]);
  const [gridData, setGridData] = useState<Service[]>();
  const { data, isLoading, isFetching } = useLoadData<ApiResponse<Service[]>>(
    servicesApiKeyStore.getServiceMunicipalityMappings(municipalityID),
    !!municipalityID
  );

  useEffect(() => {
    if (data) {
      const updatedData = allServices.map((d) => {
        const currentSelected = data?.data?.find((s) => s.serviceID === d.serviceID);
        return {
          ...d,
          ...currentSelected,
          isSelected: !!currentSelected,
        };
      });
      setGridData(updatedData);
      setSelectedServices(updatedData.filter((s) => s.isSelected));
    }
  }, [data]);

  useEffect(() => {
    onSelectedItems(selectedServices);
  }, [selectedServices]);

  const handleServiceSelection = (values: Service[]) => {
    setSelectedServices(values);
  };

  const handleServiceEdit = (value: Service) => {
    const index = selectedServices.findIndex((s) => s.serviceID === value.serviceID);
    if (index >= 0) {
      selectedServices[index] = value;
      setSelectedServices(selectedServices);
    }
  };

  return (
    <Grid item>
      <SiTrackGrid
        fileTitle='service_municipality'
        dataItemKey="serviceID"
        columns={munimappingdialogcolumns}
        dataItems={gridData}
        selectedField="isSelected"
        onSelectedItems={handleServiceSelection}
        onEditComplete={handleServiceEdit}
        actionPermissions={{
          export: UserPermissionName.DOWNLOAD_GRID,
        }}
        isBusy={isLoading || isFetching}
      />
    </Grid>
  );
};
